import React, { FC } from 'react';

import CarRentalHomeSearchBarContent from './home';
import { CarRentalSearchBarProvider } from './home/context';

interface ICarRentalSearch {
  isHomePage?: boolean;
  alignVertical?: boolean;
}

const CarRentalHomeSearchBar: FC<ICarRentalSearch> = ({ alignVertical }) => {
  return (
    <CarRentalSearchBarProvider>
      <CarRentalHomeSearchBarContent alignVertical={alignVertical} />
    </CarRentalSearchBarProvider>
  );
};

export default CarRentalHomeSearchBar;
